module.exports = __webpack_public_path__ + "img/list-pattern1.ab0bebf.svg";